<div class="form-group-query">
    <div class="type-style">
        <input type="checkbox"
        [readOnly]="IsReadOnly()"
        [checked]="isChecked"
        [formControl]="formControl"
        [formlyAttributes]="field"
        (click)="manageCheck();$event.preventDefault();">
    </div>
    <div>
        <label for="checkbox" class="label-query">{{to.label}}</label>
    </div>
    <div style="margin-left: 20px;" *ngIf="lastSection">
        <label class="label-query">(Last Selection)</label>
    </div>
</div>